'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var moment = require('moment-timezone');

// Prepare to display dates in md-datepickers
// Convert them using Feis timezone

var convertMsToDate = exports.convertMsToDate = function convertMsToDate(ms, feisTz) {
  var dateStr = moment.tz(ms, feisTz).format('MMMM D, YYYY');
  return new Date(dateStr);
};

// Prepare to save dates in db
// Convert them using Feis timezone

var convertDateToMs = exports.convertDateToMs = function convertDateToMs(date, feisTz) {
  var endOfDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var dateStr = moment(date).format('YYYY-MM-DD');
  var momentObjectInFeisTz = moment.tz(dateStr, feisTz);
  return endOfDay ? momentObjectInFeisTz.hour(23).minutes(59).seconds(59).valueOf() : momentObjectInFeisTz.valueOf();
};


//////////////////
// WEBPACK FOOTER
// ./common/utils/date-utils.js
// module id = 136
// module chunks = 0